import Styled from 'styled-components';

export default Styled.div`
    width: 58px;
    height: 58px;

    .progress_title {
      font-family: 'Mulish';
      font-size: 14px;
      font-weight: 700;
      line-height: 17.57px;
      color: #178EAB;
      img {
        &.noProgress {
          opacity: 0.5;
        }
      }
    }
`;
